export const UnsupportedDevice = ()=> {

    return (
        <div>
            <strong>
            Unfortunately this device is not supported. Please reopen the site on a desktop computer.
            </strong>
        </div>
    )
}